import { render } from "./Dungeon.vue?vue&type=template&id=583738ff"
import script from "./Dungeon.vue?vue&type=script&lang=js"
export * from "./Dungeon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__